import { call, put } from "redux-saga/effects";

import { apiRouting, queryBuilder, notify } from "services";
import { IPaginateRequest } from "interfaces/paginate-duck";
import { requestErrorHandler } from "utils";
import { PaginatePickingQuarentinesActions } from "store/ducks/picking-quarentines";

export function* paginatePickingQuarentinesRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiRouting.get,
      `/picking-quarentines?${queryString}`
    );

    const { pickingQuarentines, pagination } = responseBody;
    yield put(PaginatePickingQuarentinesActions.success(pickingQuarentines, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(PaginatePickingQuarentinesActions.failure(errorMessage));
  }
}
